<div class="modal-header">
  <h3 class="modal-title"><strong>{{modalTitle}}</strong></h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" id="FTC_BT_UD_1" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <div class="panel-body">
    <div class="radio-toggle-container">
      <label>
        <input id="FTC_BT_UD_2" type="radio" [(ngModel)]="formData.panel" [value]="true" (change)="onRadioChange()">Creditable Tax
      </label>
      <label>
        <input id="FTC_BT_UD_3" type="radio" [(ngModel)]="formData.panel" [value]="false" (change)="onRadioChange()">TB Amount Not Creditable
      </label>
    </div>

    @if (formData.enableCreditablePanel) {
<div>
      <div>
        <table class="table table-striped blue custom-table" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">Creditable Tax</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Basket</td>
              <td>
                <select id="FTC_BT_UD_4" class="form-control form-control-responsive" [(ngModel)]="formData.selectedBasketCatg" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Basket</option>
                  @for (creditable of basketCatgData; track $index) {
<option [ngValue]="'' + creditable.CODE_KEY">
                    {{creditable.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Branch Taxes per Trial Balance</td>
              <td>
                <input id="FTC_BT_UD_5" type="text" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.branchTaxTrailBalanceAmt" 
                       style="height: 30px;" 
                       [disabled]="true">
              </td>
            </tr>
            <tr>
              <td>Branch Tax LEID</td>
              <td>
                <select gtwSearchableSelect id="FTC_BT_UD_6" class="form-control form-control-responsive" [(ngModel)]="formData.genLeid" 
                        (change)="changeLeCountry()"
                        style="height: 30px;">
                  <option [ngValue]="null">Select LEID</option>
                  @for (generatedLeid of formData.generatedLeidDropDown; track $index) {
<option 
                          [ngValue]="generatedLeid.LEID_LABEL">
                    {{generatedLeid.LEID_VALUE}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Total Branch Tax</td>
              <td>
                <input id="FTC_BT_UD_7" type="text" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.totalBranchTaxes" 
                       style="height: 30px;" 
                       [disabled]="true">
              </td>
            </tr>
            <tr>
              <td>Country</td>
              <td>
                <select gtwSearchableSelect id="FTC_BT_UD_8" class="form-control form-control-responsive" [(ngModel)]="formData.selectedCountryDesc" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Country</option>
                  @for (c of countryData; track $index) {
<option [ngValue]="c.CODE_DISP_DESC">
                    {{c.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input id="FTC_BT_UD_9" type="text" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.variance" 
                       style="height: 30px;" 
                       [disabled]="true">
              </td>
            </tr>
            <tr>
              <td>Branch Tax</td>
              <td>
                <input id="FTC_BT_UD_10" type="number" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.creditTaxAmt" 
                       style="height: 30px;">
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Applicable Year</td>
              <td>
                <select id="FTC_BT_UD_11" class="form-control form-control-responsive" [(ngModel)]="formData.applicableYearKey" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Year</option>
                  @for (creditable of filteredTaxYearForCreditable; track $index) {
<option 
                          [ngValue]="'' + creditable.CODE_KEY">
                    {{creditable.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Explain why Branch Tax LEID is US entity</td>
              <td>
                <textarea id="FTC_BT_UD_12" class="form-control form-control-responsive" 
                          [(ngModel)]="formData.explainUsEntity" 
                          [disabled]="formData.selectedBranchTaxLEID_Orgnl_CountryKey != countryUS[0]?.CODE_KEY"
                          style="height: 50px; overflow:scroll; resize:vertical;" 
                          maxlength="498"></textarea>
                <label style="font-weight: normal;font-size:x-small;color: gray;">Max length 500</label>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      @if (!formData.ReturnAsFiled) {
<div class="modal-footer">
        <button id="FTC_BT_UD_13" class="btn btn-info btn-sm" type="button" 
                (click)="saveCreditAmtBranchTaxForm()" [disabled]="isSaveClicked">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button id="FTC_BT_UD_14" class="btn btn-danger-outline btn-sm" type="button" 
                (click)="resetCreditable()">Reset</button>
        <button id="FTC_BT_UD_15" class="btn btn-warning btn-sm" type="button" 
                (click)="cancel()">Cancel</button>
      </div>
}
      <br><br>

      <!-- Creditable Records Table - matching AngularJS ng-if="(ctrl.defaultsMultipleSelected | filter: { IS_CREDITABLE : 'Y' }).length > 0" -->
      @if (creditableRecords.length > 0 || formData.spinner) {
<div>
        <table class="table custom-table" style="text-align: left;">
          <thead>
            <tr>
              <th width="3%"></th>
              <th width="3%"></th>
              <th>Branch Tax LEID</th>
              <th>Country</th>
              <th>Basket</th>
              <th>Branch Tax</th>
              <th>Applicable Year</th>
              <th>Explanation</th>
            </tr>
          </thead>
          <tbody>
            <!-- Data rows - hidden when spinner is active (matching ng-show="!ctrl.formData.spinner") -->
            @if (!formData.spinner) {

              @for (t of creditableRecords; track $index) {
<tr>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i 
                     style="font-size:24px; cursor: pointer;"
                     class="fa fa-minus-circle color-red" 
                     (click)="deleteRow(t)"></i>
}
                </td>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i 
                     style="font-size:18px; margin-left:1px; cursor: pointer;"
                     class="glyphicon glyphicon-pencil"
                     (click)="editCreditableTaxRow(t)"></i>
}
                </td>
                <td>{{ t.GEN_LEID }}</td>
                <td>{{ t.COUNTRY }}</td>
                <td>{{ t.BASKET }}</td>
                <td [ngClass]="{'color-red': t.CREDIT_AMT < 0 }">{{ numberWithCommas(t.CREDIT_AMT) }}</td>
                <td>{{ t.APPLICABLE_YEAR }}</td>
                <td>{{ t.EXPLANATION_CREDITABLE_US_ENTITY }}</td>
              </tr>
}
            
}
            <!-- Spinner row - shown when loading -->
            @if (formData.spinner) {
<tr>
              <td colspan="8" style="text-align: center;">
                <i class="fa fa-spinner fa-pulse fa-2x"></i>
                <span style="margin-left: 10px;">Loading...</span>
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    @if (formData.enableNonCreditablePanel) {
<div>
      <div>
        <table class="table table-striped blue custom-table" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">TB Amount Not Creditable</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Standard Reason Amount is Not Creditable</td>
              <td>
                <select id="FTC_BT_UD_18" class="form-control form-control-responsive" [(ngModel)]="formData.selectStdReasonCd" 
                        (change)="isTaxPriorYear()"
                        style="height: 30px;">
                  <option [ngValue]="null">Select Reason</option>
                  @for (creditable of stdReasonCodeData; track $index) {
<option [ngValue]="'' + creditable.CODE_KEY">
                    {{creditable.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Applicable Year</td>
              <td>
                <select id="FTC_BT_UD_19" class="form-control form-control-responsive" [(ngModel)]="formData.applicableYearKey2" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Year</option>
                  @for (creditable of filteredTaxYearData; track $index) {
<option [ngValue]="'' + creditable.CODE_KEY">
                    {{creditable.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>
                <input id="FTC_BT_UD_20" type="number" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.nonCrdBrAmount" 
                       style="height: 30px;">
              </td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input id="FTC_BT_UD_21" type="text" class="form-control form-control-responsive" 
                       [(ngModel)]="formData.openVariance" 
                       style="height: 30px;" 
                       [disabled]="true">
              </td>
            </tr>
            @if (formData.isSection909SplitrTax) {
<tr>
              <td>Basket</td>
              <td>
                <select id="FTC_BT_UD_22" class="form-control form-control-responsive" [(ngModel)]="formData.selectedSplitterBasketCatg" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Basket</option>
                  @for (creditable of basketCatgData; track $index) {
<option [ngValue]="'' + creditable.CODE_KEY">
                    {{creditable.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Country</td>
              <td>
                <select gtwSearchableSelect id="FTC_BT_UD_23" class="form-control form-control-responsive" [(ngModel)]="formData.selectedSplitterCountryDesc" 
                        style="height: 30px;">
                  <option [ngValue]="null">Select Country</option>
                  @for (c of countryData; track $index) {
<option [ngValue]="c.CODE_DISP_DESC">
                    {{c.CODE_DISP_DESC}}
                  </option>
}
                </select>
              </td>
            </tr>
}
            <tr>
              <td>Detailed Reason Amount is Not Creditable</td>
              <td>
                <textarea id="FTC_BT_UD_24" class="form-control form-control-responsive" 
                          [(ngModel)]="formData.detailReason" 
                          style="height: 50px; overflow:scroll; resize:vertical;" 
                          maxlength="498"></textarea>
                <label style="font-weight: normal;font-size:x-small;color: gray;">Max length 500</label>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      @if (!formData.ReturnAsFiled) {
<div class="modal-footer">
        <button id="FTC_BT_UD_25" class="btn btn-info btn-sm" type="button" 
                (click)="saveNonCreditAmtBranchTaxForm()" [disabled]="isSaveClicked">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button id="FTC_BT_UD_26" class="btn btn-danger-outline btn-sm" type="button" 
                (click)="resetNonCreditable()">Reset</button>
        <button id="FTC_BT_UD_27" class="btn btn-warning btn-sm" type="button" 
                (click)="cancel()">Cancel</button>
      </div>
}
      <br><br>

      <!-- Non-Creditable Records Table - matching AngularJS ng-if="(ctrl.defaultsMultipleSelected | filter: { IS_CREDITABLE : 'N' }).length > 0" -->
      @if (nonCreditableRecords.length > 0 || formData.spinner) {
<div>
        <table class="table custom-table" style="text-align: left;table-layout: fixed;">
          <thead>
            <tr>
              <th width="5%"></th>
              <th width="5%"></th>
              <th width="20%">Standard Reason Amount is Not Creditable</th>
              <th width="15%">Applicable Year</th>
              <th width="15%">Amount</th>
              <th>Detailed Reason Amount is Not Creditable</th>
            </tr>
          </thead>
          <tbody>
            <!-- Data rows - hidden when spinner is active (matching ng-show="!ctrl.formData.spinner") -->
            @if (!formData.spinner) {

              @for (t of nonCreditableRecords; track $index) {
<tr>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i 
                     style="font-size:24px; cursor: pointer;"
                     class="fa fa-minus-circle color-red" 
                     (click)="deleteRow(t)"></i>
}
                </td>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i 
                     style="font-size:18px; margin-left:1px; cursor: pointer;"
                     class="glyphicon glyphicon-pencil"
                     (click)="editNonCreditableTaxRow(t)"></i>
}
                </td>
                <td>{{ t.STANDARD_REASON_NOT_CREDITABLE }}</td>
                <td>{{ t.APPLICABLE_YEAR2 }}</td>
                <td [ngClass]="{'color-red': t.NON_CREDIT_AMT < 0 }">{{ numberWithCommas(t.NON_CREDIT_AMT) }}</td>
                <td style="word-wrap: break-word">{{ t.DETAIL_REASON_NOT_CREDITABLE }}</td>
              </tr>
}
            
}
            <!-- Spinner row - shown when loading -->
            @if (formData.spinner) {
<tr>
              <td colspan="6" style="text-align: center;">
                <i class="fa fa-spinner fa-pulse fa-2x"></i>
                <span style="margin-left: 10px;">Loading...</span>
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}
  </div>
</div>

